<template>
  <div class="login_page">
    <v-container>
      <div class="login_content">
        <div class="login_left_side">
          <div class="logo_in_login pt-40">
            <a href="https://wereldo.com/"><img
                src="@/assets/logo.png"
                alt="logo"
                height="45"
              ></a>
          </div>
          <img
            src="@/assets/img/login-img.jpg"
            alt=""
          >
        </div>
        <div class="login_right_side">
          <v-form v-model="isValid">
            <template v-if="signUpType === 'createAccount'">
              <label>{{$t('signup.organization_name')}}</label>
              <v-text-field
                prepend-inner-icon="fas fa-building"
                :name="$t('signup.organization_name')"
                :label="$t('signup.organization_name')"
                type="text"
                :rules="[Required]"
                v-model="formData.orgName"
                solo
              ></v-text-field>
            </template>
            <template v-if="signUpType === 'createAccount'">
              <label>{{$t('signup.organization_reg_number')}}</label>
              <v-text-field
                v-if="signUpType === 'createAccount'"
                prepend-inner-icon="fas fa-building"
                :name="$t('signup.organization_reg_number')"
                :label="$t('signup.organization_reg_number')"
                type="text"
                :rules="[Required]"
                v-model="formData.regNo"
                solo
              ></v-text-field>
            </template>
            <label>{{$t('login.email')}}</label>
            <v-text-field
              prepend-inner-icon="fas fa-at"
              :name="$t('login.email')"
              :label="$t('login.email')"
              type="text"
              :rules="[Required, Email]"
              v-model="formData.email"
              solo
            ></v-text-field>
            <template v-if="signUpType === 'createAccount'">
              <label>{{$t('login.password')}}</label>
              <v-text-field
                prepend-inner-icon="fas fa-lock"
                :append-icon="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                :name="$t('login.password')"
                :label="$t('login.password')"
                :type="showPassword ? 'text' : 'password'"
                :rules="[Required, PasswordLength, PasswordLetters, PasswordNumber]"
                @click:append="showPassword = !showPassword"
                v-model="formData.password"
                solo
              >
              </v-text-field>
            </template>
            <label>{{$t('signup.name')}}</label>
            <v-text-field
              prepend-inner-icon="person"
              :name="$t('signup.name')"
              :label="$t('signup.name')"
              type="text"
              :rules="[Required]"
              v-model="formData.given"
              solo
            ></v-text-field>
            <label>{{$t('signup.surname')}}</label>
            <v-text-field
              prepend-inner-icon="person"
              :name="$t('signup.surname')"
              :label="$t('signup.surname')"
              type="text"
              :rules="[Required]"
              v-model="formData.last"
              solo
            ></v-text-field>
            <v-btn
              v-if="!isLoadingSignUp"
              rounded
              block
              color="accent"
              @click="submit"
              class="mb-3"
              :disabled="!isValid"
            >
             {{$t('signup.sign_up')}}
            </v-btn>
            <v-btn
              v-else
              rounded
              block
              color="accent"
              class="mb-3"
              :disabled="true"
            >
              <v-progress-circular
                size="20"
                width="3"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-btn>
            <v-btn
              rounded
              block
              color="accent"
              :to="{ path: '/login' }"
              class="mb-3"
            >{{$t('signup.log_in')}}</v-btn>
          </v-form>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { signUp, addUser } from '@/_services/amplify.service.js'
import { mapActions } from 'vuex'
import { Required, Email, PasswordLength, PasswordLetters, PasswordNumber } from '@/plugins/form-validations.js'

export default {
  name: 'SignUp',
  data () {
    return {
      Required,
      Email,
      PasswordLength,
      PasswordLetters,
      PasswordNumber,
      formData: {
        orgName: null,
        regNo: null,
        email: null,
        password: null,
        given: null,
        last: null,
        username: null
      },
      isValid: false,
      showPassword: false,
      signUpType: 'createAccount',
      isLoadingSignUp: false
    }
  },
  mounted () {
    this.signUpType = 'createAccount'
    // if (this.$route.query !== undefined) {
    //   this.signUpType = this.$route.query.signUpType
    // }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    submit () {
      this.isLoadingSignUp = true
      if (this.signUpType === 'createAccount') {
        this.handleCreateAccount()
      } else if (this.signUpType === 'addUser') {
        this.handleAddUser()
      }
    },
    handleCreateAccount () {
      this.formData.username = uuid.v4()
      const mapFormData = { attributes: {}, validationData: [] }
      Object.keys(this.formData).forEach((key) => {
        if (key === 'password') {
          mapFormData[key] = this.formData[key]
        } else if (key === 'username') {
          mapFormData[key] = uuid.v4()
        } else if (key === 'email') {
          mapFormData['attributes'][key] = this.formData[key]
        } else {
          mapFormData['validationData'].push({ Name: key, Value: this.formData[key] })
        }
      })
      signUp(mapFormData).then((response) => {
        this.showSnackbar({ message: 'Check your email for verification link!!', color: 'success' })
        // Predefine language
        if (this.$i18n.locale === 'cs') {
          window.location.replace(`https://www.wereldo.com/cz/welcome`)
        } else {
          window.location.replace(`https://www.wereldo.com/welcome`)
        }
        // this.$router.push({ path: '/login' })
      }).catch((error) => {
        console.error(error)
        this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
      }).finally(() => {
        this.isLoadingSignUp = false
      })
    },
    handleAddUser () {
      const mapFormData = {
        givenName: this.formData.given,
        familyName: this.formData.last,
        email: this.formData.email,
        group: 'Members'
      }
      addUser(mapFormData).then((response) => {
        this.showSnackbar({ message: 'New User Added', color: 'success' })
        this.$router.push({ path: '/' })
      }).catch((error) => {
        console.error(error)
        this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
      }).finally(() => {
        this.isLoadingSignUp = false
      })
    }
  },
  computed: {},
  watch: {
    '$route.query.signUpType': {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.signUpType = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
    color: #484848;
    margin-top: 0px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.2;
    font-size: 35px;
    margin-bottom: 2em;
  }
  .login_page {
    width: 100%;
    padding: 0;
    margin: 0;
    background: #fff;
    min-height: 100vh;
    background: linear-gradient(to left, #e9f1f2 50%, #fff 50%);
  }
  .login_content {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
  }

.login_left_side {
  padding: 0px;
  flex-basis: 50%;
  -webkit-flex-basis: 50%;
  padding-right: 3em;
  padding-top: 3em;
}

.login_left_side img {
  width: 100%;
}

.logo_in_login img {
  width: auto;
  margin-top: 10px;
}

.login_right_side {
  flex-basis: 50%;
  -webkit-flex-basis: 50%;
  box-sizing: border-box;
  padding: 3em 4em;
}

.login_terms a {
  color: #267885;
}

@media (max-width: 992px) {
  .login_page {
    background: #e9f1f2;
  }

  .login_left_side {
    display: none;
  }

  .login_right_side {
    flex-basis: 100%;
    -webkit-flex-basis: 100%;
    padding: 3em 4em;
  }
}
@media (max-width: 992px) {
  .login_right_side {
    padding: 3em 1em;
  }
}
  .indicator {
    height: 18px;
    width: 18px;
    border-radius: 50%;
    display: inline-block;
    background-color: #b2b2b2;
  }
  .green-dot {
    background-color: #32ea32;
  }
  .restriction-label {
    margin-left: 8px;
    font-size: 18px;
  }
  .back-to-normal-login {
    cursor: pointer;
    margin-bottom: 5px;
    font-size: 12px;
  }
</style>
